import React from 'react';
import { Helmet } from 'react-helmet';

const BreadcrumbSchema = ({ breadcrumbs = [] }) => {
  // Default breadcrumbs for homepage
  const defaultBreadcrumbs = [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://www.tensorpilot.io/"
    },
    {
      "@type": "ListItem", 
      "position": 2,
      "name": "Download",
      "item": "https://www.tensorpilot.io/download"
    },
    {
      "@type": "ListItem",
      "position": 3,
      "name": "Pricing",
      "item": "https://www.tensorpilot.io/sales"
    },
    {
      "@type": "ListItem",
      "position": 4,
      "name": "Blog",
      "item": "https://www.tensorpilot.io/blog"
    }
  ];

  const breadcrumbData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbs.length > 0 ? breadcrumbs : defaultBreadcrumbs
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbData)}
      </script>
    </Helmet>
  );
};

export default BreadcrumbSchema;
